import Typography from '@/ui/components/typography'
import { SectionHeaderProps } from './SectionHeader.types'
import {
    SectionHeaderWrapper,
    RedBullet,
    SectionTitle,
} from './SectionHeader.styles'

const SectionHeader = ({ title, dataTestId }: SectionHeaderProps) => {
    return (
        <SectionHeaderWrapper data-testid={dataTestId}>
            <RedBullet />
            <SectionTitle>
                <Typography variant="s-semibold">{title}</Typography>
            </SectionTitle>
        </SectionHeaderWrapper>
    )
}

export default SectionHeader
